import IrFavoriteButtonFloating from './FavoriteButtonFloating.vue';
import FavoriteSignUpModal from '../../../Modal/FavoriteSignUpModal.vue';
import NameModal from '../../Modal/NameModal.vue';

/**
 * 個別銘柄IRページ ルートコンポーネント
 *
 * @vue-components {IrFavoriteButtonFloating} IrFavoriteButtonFloating お気に入りボタン
 * @vue-components {FavoriteSignUpModal} FavoriteSignUpModal お気に入りボタン用の会員登録誘導モーダル
 * @vue-components {NameModal} NameModal 名前モーダル
 * @property {boolean} showModal モーダルを表示するかどうか
 * @module Stocks
 */
const StocksIR = {
  el: '#v-stocks-ir',
  components: {
    IrFavoriteButtonFloating,
    FavoriteSignUpModal,
    NameModal,
  },
  methods: {
    /**
     * IRメニューのモーダルを表示する
     * @param {string} name
     * @return {void}
     */
    async open(name) {
      this.$store.commit('show', name);
    },
    /**
     * メニュー内リンククリック時にモーダルを閉じる
     * @param {Function} hide NameModal から渡される hide
     * @param {Event} event クリックイベント
     */
    handleLinkClick(hide, event) {
      if (typeof hide !== 'function') return;
      const link = event.target && event.target.closest('a');
      if (!link) return;
      hide();
    },
  },
};
export default StocksIR;
